import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

type Params = {
  from: string | undefined;
  birth: string | null;
};

export const useLogCompleteEditMyInfo = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ from, birth }: Params) => {
      logAnalyticsEvent({
        name: 'COMPLETE_EDIT_MY_INFO',
        analytics: {
          FROM: from ?? null,
          BIRTH: birth,
        },
      });
    },
    [logAnalyticsEvent],
  );
};
